<template>
  <div class="activeType">
    <div v-show="createStep == 1">
      <div class="">
        <div class="new-top-bg-box">
          <jd-form
            ref="inputForm"
            :formInfo="inputData2"
            @search="searchContent"
          ></jd-form>
        </div>

        <div class="new-bottom-bg-box" style="margin: 0; margin-top: 16px;">
          <div style="text-align: right;margin-bottom: 16px;"><el-checkbox v-model="createByMe" @change="handleCreateByMe">我创建的</el-checkbox></div>
          <!-- 表格内容 -->
          <div class="new-table-box" style="margin-top: 16px">
            <jd-table
              :tableData="activityList"
              :loading="talbeLoading"
              style="width: 100%;"
              ref="table"
              :pageInfo="{
                pageNum: recordData.current,
                pageSize: recordData.size,
                noShow: false,
                total: totalNum,
              }"
              @handlePage="handlePages"
            >
              <el-table-column label="计划名称">
                <template slot-scope="scope">
                  <div class="activityName">
                    <span style="margin-left:5px">{{ scope.row.activityName }}</span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="计划时间">
                <template slot-scope="scope">
                  <div class="activityTime">
                    <span>起: {{ scope.row.startTime }}</span
                    ><br />
                    <span>止: {{ scope.row.endTime }}</span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="最后修改时间" prop="updateTime"> </el-table-column>
              <el-table-column label="活动状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 1"> 
                    <i class="yellow-status-icon" style="margin-right: 4px;"></i>
                    未开始
                  </span>
                  <span v-if="scope.row.status == 2">
                    <i class="blue-status-icon" style="margin-right: 4px;"></i>
                    进行中
                  </span>
                  <span v-if="scope.row.status == 3">
                    <i class="grey-status-icon" style="margin-right: 4px;"></i>
                    已结束
                  </span>
                  <el-tooltip class="item" effect="light" v-if="scope.row.reason && scope.row.status == 3" :content="scope.row.reason" placement="bottom">
                    <el-button type="text">
                      <i class="el-icon-question" style="color: #ccc;"></i>
                    </el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column label="参与人数" width="120" prop="joinNum">
                <template slot-scope="scope">
                  {{scope.row.joinNum || 0}}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="240">
                <template slot-scope="scope">
                  <jd-button v-if="scope.row.status != 3" @click="modify(scope.row.activityType, scope.row)" type="blueText">
                      修改
                    </jd-button>
                    <jd-button v-else disabled type="blueText">
                      修改
                    </jd-button>
                    <jd-button @click="statisData(scope.row)" type="blueText">数据统计</jd-button>
                    <jd-button @click="modify(scope.row.activityType, scope.row, 'look')" type="blueText">
                      查看
                    </jd-button>
                  <el-dropdown>
                    <jd-button type="blueText" class="ml14 new_add_more">更多</jd-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>
                        <jd-button @click="modify(scope.row.activityType, scope.row, 'copy')" type="blueText">
                          复制
                        </jd-button>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <jd-button v-if="scope.row.status != 3" @click="endenActivity(scope.row.id)" type="blueText">结束</jd-button>
                        <jd-button v-else type="blueText" disabled>
                          结束
                        </jd-button>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <jd-button @click="deleteActivity(scope.row)" type="blueText">删除</jd-button>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </jd-table>
          </div>
          
        </div>
      </div>
    </div>
    <statistics v-if="createStep == 2" @returnStep="returnStep" :rowData="rowData" :ids1="ids1"></statistics>
  </div>
</template>

<script>
import giftTmp from "./giftTmp.js";
import inputForm from "@/components/jhk/inputForm";
import { queryActivity, endEvent, deleteEvent, authCheck, getValidActivity } from "@/api/jhk/activityController";
import statistics from "../activity/activity_data_statistics.vue";

export default {
  name: "activeType",
  mixins: [giftTmp],
  components: {
    inputForm,
    statistics,
  },
  data() {
    return {
      statisticsShow: 1,
      form: {
        name: "",
        id: "",
      },
      currIndex: 0,
      ids: "",
      rowData: {},
      createByMe: false,
      // tempIndex: 0,
      // tempSwitchList: ["全部", "618", "双11", "双12"],
      // activityData: {},
      inputData2: [
        {
          label: "计划名称：",
          prop: "activityName",
          type: "Input",
          value: "",
          placeholder: "请输入活动名称",
        },
        {
          label: "活动状态：",
          prop: "status",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "未开始", value: 1 },
            { label: "进行中", value: 2 },
            { label: "已结束", value: 3 },
          ],
        },
        {
          label: "计划类型：",
          prop: "activityType",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: ""},
            { label: "0元试用", value: 33 },
            { label: "会员卡片", value: 32 },
            { label: "刮刮乐", value: 26 }, 
            { label: "智能活动海报", value: 25 },
          ],
        },
        {
          label: "计划时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startTime: "",
          endTime: ""
        },
        {
          label: "最后修改时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startUpdateTime",
          endKey: "endUpdateTime",
          startTime: "",
          endTime: ""
        },
      ],
      activityList: [],
      currentPage: 1,
      totalNum: 0,
      recordData: {
        size: 10,
        current: 1,
      },
      talbeLoading: false,
      outerVisible: false,
      outerVisibleTwo: false,
      createStep: 1,
    };  
  },
  
  created() {
    if (this.$route.query.activityType) {
      this.inputData2[2].value = Number(this.$route.query.activityType);
      this.recordData.activityType = Number(this.$route.query.activityType);
      this.$nextTick(()=>{
        this.$refs.inputForm.reData();
      })
    }
    this.queryList();
  },
  methods: {
    handleCreateByMe() {
      this.recordData.current = 1
      this.queryList();
    },
    handleWord() {
      if (this.activityData.course) {
        window.open(this.activityData.course, "_blank");
      }
    },
    //活动管理查询
    queryList() {
      this.talbeLoading = true;
      this.recordData.activityPlusMainTypes = 6;
      // this.recordData.activityType = this.$route.query.activityType;
      this.talbeLoading = true;
      queryActivity({...this.recordData,createByMe: this.createByMe})
        .then((res) => {
          this.talbeLoading = false;
          let mesUrl = "";
          this.activityList = res.data.records;
          this.totalNum = Number(res.data.total);
        })
        .catch(() => {});
    },
    searchContent(form) {
      this.recordData.activityType = form.activityType;
      this.recordData.current = 1;
      this.recordData.activityName = form.activityName;
      this.recordData.startTime = form.startTime;
      this.recordData.endTime = form.endTime;
      this.recordData.startUpdateTime = form.startUpdateTime;
      this.recordData.endUpdateTime = form.endUpdateTime;
      this.recordData.status = form.status;
      this.queryList();
    },
    
    // 删除
    handleDeleteTableTwo() {
      if (this.status == 2) {
        this.$message.error("先结束活动再进行删除");
      } else {
        let id = this.ids;
        deleteEvent(id)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success("删除成功");
              this.queryList();
            }
          })
          .catch(() => {
            this.$message.error("删除失败");
          });
      }
    },
    //结束确定
    handleDeleteTable() {
      let id = this.ids;
      endEvent(id)
        .then((res) => {
          if (res && res.code == 1) {
            this.$message.success("操作成功");
            this.queryList();
          }
        })
        .catch(() => {
          if (res.code == 10100) {
            this.$message.error("活动未开始不能结束活动");
          } else {
            this.$message.error("操作失败");
          }
        });
    },
    // 分页查询事件
    handlePages(page) {
      this.recordData.current = page.pageNum;
      this.recordData.size = page.pageSize;
      this.queryList();
    },
    //删除活动
    deleteActivity(id) {
      this.status = id.status;
      this.ids = id.id;
      this.$confirm("是否删除活动?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(() => {
        this.handleDeleteTableTwo();
      }).catch(() => {
      });
    },
    //结束活动
    endenActivity(id) {
      this.ids = id;
      this.$confirm("是否结束活动?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(() => {
        this.handleDeleteTable();
      }).catch(() => {
      });
    },
    //修改
    async modify(row, val, type = "edit") {
      this.backgroundOpacity = type == "look" ? true : false;
      if(type != "copy"){  // 复制跳过此逻辑
        // 进行中的活动  去掉保存按钮
        if (val.status == 2) {
          this.isSave = false;
        } else {
          this.isSave = true;
        }
        // 评价有礼 修改禁用一些输入框
        this.statusComment = false;
      }else{
        let session = row;
        const res = await getValidActivity(session == 25 ? 1 : session == 26 ? 2 : session == 32 ? 3 : 4);
        if(res && res.data.isOpen){
          return this.$message.warning(res.data.message);
        }
      }
      let params = {
        valueRow: val.id,
        statusComment: this.statusComment,
        isSave: this.isSave,
        backgroundOpacity: this.backgroundOpacity,
        activeValue: row,
        isCopy: type == "copy" ? 1 : 0,
      };
      if (val.activityType == 25) this.$router.push({ name: "smartPosterEdit", query: params });
      if (val.activityType == 26) this.$router.push({ name: "scratchersEdit", query: params });
      if (val.activityType == 32) this.$router.push({ name: "memberCardEdit", query: params });
      if (val.activityType == 33) this.$router.push({ name: "freeTrialEdit", query: params });
    },
    //数据统计
    statisData(row) {
      this.rowData = row;
      this.ids1 = row.id;
      this.createStep = 2;
    },
    returnStep() {
      this.createStep = 1;
      this.recordData.current = 1;
      this.recordData.size = 10;
      this.queryList();
      // console.log(this.recordData,99988);
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
  },
};
</script>

<style lang="scss" scoped>
.card-point {
  width: 97%;
  background: #fffaee;
  border-radius: 4px;
  margin: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    margin-left: 12px;
    padding-left: 18px;
    width: 90px;
    background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.activeType {
  // background: #ffffff;
  // padding-bottom: 24px;
  &_title {
    width: 100%;
    height: 40px;
    font-weight: 600;
    padding-left: 24px;
    font-size: 16px;
    margin-bottom: 24px;
    border-bottom: 1px solid #f0f0f0;
  }
  &_top {
    padding: 0 24px;
    display: flex;
    .content-left {
      width: 184px;
      height: 336px;
      background: rgba(255, 255, 255, 0.2);
      box-shadow: 0px 4px 20px 1px rgba(18, 10, 60, 0.15);
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #ffffff;
      margin-bottom: 40px;
    }
    .content-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-left: 33px;
      margin-top: 16px;
      padding-bottom: 40px;
    }
    .sign {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      margin-bottom: 12px;
      display: flex;
      align-items: end;
      &_jc {
        font-size: 14px;
        color: #999999;
        margin-left: 5px;
        display: flex;
        &::before {
          content: "";
          width: 15px;
          height: 15px;
          margin-right: 4px;
          background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/u103.png") no-repeat;
          background-size: 15px 15px;
        }
      }
    }
    .sign_desc {
      font-size: 14px;
      color: rgb(151, 151, 151);
      line-height: 17px;
    }
    .QRcode {
      width: 150px;
      height: 170px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #000000;
      margin-bottom: 40px; // margin-top: 105px;
      &_img {
        width: 100%;
        height: 150px;
        background: white;
        box-shadow: 0px 4px 20px 1px rgba(18, 10, 60, 0.15);
        border-radius: 12px 12px 12px 12px;
        border: 1px solid #ffffff;
        margin-bottom: 10px;
      }
      &_btn {
        width: 96px;
        height: 32px;
        // line-height: 32px;
        // text-align: center;
        background: #7b61ff;
        border-radius: 4px 4px 4px 4px;
        margin-top: 24px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        &::before {
          content: "";
          width: 19px;
          height: 19px;
          margin-right: 5px;
          background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/add.svg") no-repeat;
        }
      }
    }
  }
  .formClass {
    margin: 24px 0;
    display: flex;
    /deep/.el-form-item {
      margin-right: 50px;
    }
    .seach_btn {
      margin-left: auto;
      margin-right: 30px;
      display: flex;
    }
    .search,
    .reset {
      width: 98px;
      font-size: 14px;
      height: 32px;
      transition: all 0.2s;
      border-radius: 4px 4px 4px 4px;
    }
    .search {
      color: #fff;
      background-color: #7b61ff;
      &:hover {
        opacity: 0.8;
      }
    }
    .reset {
      color: #666666;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #7b61ff;
        border: 1px solid #7b61ff;
        background: rgba(38, 112, 251, 0.1);
      }
    }
  }
  &_content {
    padding: 0 24px;
  }
  .create_btn {
    margin-top: 10px;
    // margin-bottom: 8px;
    // margin-left: -20px;
  }
}
.question_icon {
  width: 14px;
  height: 14px;
  color: #cccccc;
  display: inline-block;
  line-height: 12px;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #cccccc;
  font-size: 12px;
  font-weight: normal;
}
.editList {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  span {
    // flex: 1;
    min-width: 28px;
    cursor: pointer;
  }
  .edit,
  .count {
    cursor: pointer;
    color: #7f85e9;
    &:hover {
      color: #7b61ff;
    }
  }
  .end,
  .delete {
    cursor: pointer;
    color: #7b61ff;
    text-align: center;
    // &:hover {
    //   color: #7B61FF;
    // }
  }
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
// .y1,
// .y2,
// .y3,
// .y4 {
//   display: inline-block;
//   width: 6px;
//   height: 6px;
//   border-radius: 50%;
//   margin-right: 5px;
// }
.y1 {
    color: #02b1ff;
    background-color: #e6f7ff;
  }
  .y2 {
    color: #f36f39;
    background: #fef1ec;
  }
  .y3 {
    color: #5b5b5b;
    background: #f1f1f1;
  }
.y4 {
  background-color: #49c568;
}
.buttonBox {
  .b1 {
    width: 98px;
    height: 32px;
    color: #666666;
    // position: absolute;
    border-radius: 3px;
    margin-top: 20px;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .b2 {
    width: 98px;
    // position: absolute;
    // margin-right: 80px;
    height: 32px;
    margin: 20px 80px 10px 10px;
    border: 1px solid #fe4d45;
    color: #ffffff;
    border-radius: 3px;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}
.state {
    padding: 6px 10px;
    border-radius: 17px;
    display: inline;
  }
  .content-left {
      width: 184px;
      height: 336px;
      background: rgba(255, 255, 255, 0.2);
      box-shadow: 0px 4px 20px 1px rgba(18, 10, 60, 0.15);
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #ffffff;
      margin-bottom: 40px;
      overflow: hidden;
      position: relative;
    }
  .QRcode {
      width: 150px;
      height: 170px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #000000;
      margin-top: 50px;

      &_img {
        width: 100%;
        height: 150px;
        // background: #7b61ff;
        box-shadow: 0px 4px 20px 1px rgba(18, 10, 60, 0.15);
        border-radius: 12px 12px 12px 12px;
        border: 1px solid #ffffff;
        margin-bottom: 10px;
        box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
        border-radius: 12px 12px 12px 12px;
        padding: 7px;
      }
      &_btn {
        width: 96px;
        height: 32px;
        // line-height: 32px;
        // text-align: center;
        background: #7b61ff;
        border-radius: 4px 4px 4px 4px;
        margin-top: 24px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  .ml14 {
    margin-left: 14px;
  }
</style>
